import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bdc44d42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container scrolled" }
const _hoisted_2 = { class: "list-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Usuários", -1))
const _hoisted_4 = { class: "list-header" }
const _hoisted_5 = { class: "item-data" }
const _hoisted_6 = { class: "item-operations" }
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          class: "btn btn-new",
          to: { name: 'user_new' }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Cadastrar Usuários ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("ul", {
        class: _normalizeClass({
        'list-items': true,
        loading: _ctx.isLoading,
        'empty-list': !_ctx.isLoading && !_ctx.users.length,
      })
      }, [
        (!_ctx.isLoading)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList((_ctx.users as UserModel[]), (user) => {
              return (_openBlock(), _createElementBlock("li", {
                key: user.id
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("strong", null, _toDisplayString(user.name), 1),
                  _createElementVNode("p", null, _toDisplayString(user.email), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_router_link, {
                    class: "btn",
                    to: { name: 'user_edit', params: { user_id: user.id } }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, { icon: ['fa', 'pen-square'] })
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("button", {
                    class: _normalizeClass(['btn', user.active ? 'btn-delete' : 'btn-new']),
                    onClick: ($event: any) => (_ctx.toogleStatus(user))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fa', user.active ? 'ban' : 'check']
                    }, null, 8, ["icon"])
                  ], 10, _hoisted_7)
                ])
              ]))
            }), 128))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}